// extracted by mini-css-extract-plugin
export default {"container":"socialLoginButton_container__xfRVX","button":"socialLoginButton_button__pV6Z8","logo":"socialLoginButton_logo__e9sNl","logoSize":"socialLoginButton_logoSize__TOi+N"};